
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import SupplyOrderItemSerializerForRetrieve from '../types/SupplyOrderItemSerializerForRetrieve_apps_MSD'


const HOST = `${config.API_HOST}`
/* ['generics.RetrieveAPIView'] */
/* params: 'qa_claim_id', 'change', 'mode', 'encounter', 'product', 'product_issue', 'quantity_request', 'quantity_issue', 'quantity_postpone', 'eligibility_type' */
/* data:  */
const SupplyOrderItemPreview : 
{
  retrieve: ({params, apiToken, extra}:
             {  params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  retrieve: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/MSD/supply-order-item/preview/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default SupplyOrderItemPreview

